import React from "react";

import { NavBarContext } from "./useNavBar.context";

export const useNavBar = () => {
  const context = React.useContext(NavBarContext);

  if (!context) {
    throw new Error("useNavBar must be used within a NavBarProvider");
  }

  return context;
};
